import { render, staticRenderFns } from "./brandDetail.vue?vue&type=template&id=58fb5eee&scoped=true&"
import script from "./brandDetail.vue?vue&type=script&lang=js&"
export * from "./brandDetail.vue?vue&type=script&lang=js&"
import style0 from "./brandDetail.vue?vue&type=style&index=0&id=58fb5eee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fb5eee",
  null
  
)

export default component.exports